// src/admin/views/CourseListView.js
import { useEffect, useState } from 'react'
import { FiPlus } from 'react-icons/fi'
import { useNavigate } from 'react-router-dom'
import apiClient from '../../global/utils/apiClient'
import PageHeader from '../components/PageHeader'
import { useAdminStore } from '../store/AdminStore'

function CourseListView() {
  const [courseData, setCourseData] = useState([])
  const orgName = useAdminStore((state) => state.orgName)
  const navigate = useNavigate()

  useEffect(() => {
    window.scrollTo(0, 0)
    // Fetch course data from the API when the component mounts
    apiClient.get('/gskapi/courses/allcourses')
      .then((response) => {
        setCourseData(response.data)
      })
      .catch((error) => {
        console.error('Error fetching course data:', error)
      })
  }, [])

  return (
    <>
      <PageHeader backTo={'/admin'} pageName={'Courses'} />
      {orgName && (
        <div style={{ textAlign: 'center', fontWeight: 'bold', margin: '10px 0' }}>
          {orgName}
        </div>
      )}
      <div className="add-button-container" style={{ marginTop: '20px' }}>
        <button className="btn btn-primary" onClick={() => navigate(`/admin/course`)}>
          <FiPlus style={{ marginRight: '8px' }} /> Add Course
        </button>
      </div>
      <div className="admin-list">
        {courseData.map((course) => (
          <div
            key={course.courseId}
            className="admin-list-item"
            onClick={() => navigate(`/admin/course?courseId=${course.courseId}`)}
          >
            <span className="admin-list-item-name">{course.courseName}</span>
            <span className="admin-list-item-arrow">›</span>
          </div>
        ))}
      </div>
    </>
  )
}

export default CourseListView
